import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseApi = createApi({
    reducerPath: "baseApi",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_BASE_URL,
    }),
    endpoints: (builder) => ({
        uploadToS3: builder.mutation({
            queryFn: async ({ uploadUrl, file }) => {
                try {
                    const response = await fetch(uploadUrl, {
                        method: "PUT",
                        headers: {
                            "Content-Type": file.type || "application/octet-stream",
                        },
                        body: file,
                    });
                    if (!response.ok) {
                        return { error: { status: response.status, data: await response.text() } };
                    }
                    return { data: null };
                } catch (error) {
                    return { error: { message: error.message } };
                }
            },
        }),
        sendForgetPasswordMail: builder.mutation({
            query: (email) => ({
                url: `staff/forgot/password?email=${email}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        })
    }),
});

export const { useUploadToS3Mutation,useSendForgetPasswordMailMutation } = baseApi;
